import React, { useState } from "react";
import "./../styles/OurServicesStyles.css";
import os from "./../../../assets/images/OurServices/os.jpg";
import os1 from "./../../../assets/images/OurServices/os1.png";
import os2 from "./../../../assets/images/OurServices/os2.png";
import os3 from "./../../../assets/images/OurServices/os3.png";
import os5 from "./../../../assets/images/OurServices/codehubbOs.svg";
import os6 from "./../../../assets/images/OurServices/interviewOs.svg";

import os4 from "./../../../assets/images/OurServices/os4.png";
import codehubUnselected from "./../../../assets/images/OurServices/codehubUnselect.svg";
import codehubSelected from "./../../../assets/images/OurServices/codehubSelected.svg";
import interviewHubUnselected from "./../../../assets/images/OurServices/interviewHubUnselected.svg";
import interviewHubSelected from "./../../../assets/images/OurServices/interviewSelect.svg";
import AI from "./../../../assets/images/OurServices/unselectedIcon/AI.png";
import idea from "./../../../assets/images/OurServices/unselectedIcon/idea 1.png";
import live from "./../../../assets/images/OurServices/unselectedIcon/live-broadcast (1) 1.png";
import skills from "./../../../assets/images/OurServices/unselectedIcon/skills 1.png";
import AIselected from "./../../../assets/images/OurServices/selectedIcon/Group.png";
import ideaselected from "./../../../assets/images/OurServices/selectedIcon/Group (1).png";
import skillselected from "./../../../assets/images/OurServices/selectedIcon/Group (2).png";
import liveselected from "./../../../assets/images/OurServices/selectedIcon/live-broadcast 1.png";
import boderos from "./../../../assets/images/OurServices/border.svg";
import feedbackIcon from "./../../../assets/images/OurServices/feedback.svg";
import FeedbackModal from "../components/FeedbackModal";

// Define the types for the cards and content
interface Card {
  id: number;
  title: string;
  description: string;
  content: string;
  image: string;
  selectedIcon: string; // Icon for selected state
  unselectedIcon: string; // Icon for non-selected state
}

const OurServicesPage: React.FC = () => {
  // Define the cards and content
  const cards: Card[] = [
    {
      id: 1,
      title: "AI-based Skill Assessment",
      description:
        "Leveraging advanced AI and ML technologies, Jozuna: The Assessment transforms skill development by assessing essential technical and soft skills crucial for success in today's dynamic environment. Our platform benefits schools, colleges, corporate organizations, and professionals by assessing & focusing on life and career skills, learning and  innovation skills, interpersonal skills, technological skills, and interdisciplinary competencies. Through real-time feedback and personalized learning paths, we help humans from all backgrounds reach their full potential.",
      content: "JOZUNA: The Assessment",
      image: os1,
      selectedIcon: AIselected, // Use the actual path to the selected icon
      unselectedIcon: AI, // Use the actual path to the unselected icon
    },
    {
      id: 2,
      title: "Personalized Learning Outcomes",
      description:
        "We provide personalized interactive modules to impart outcome based learning to the users. Based on one’s performance in the assessments, our AI-based system recommends videos in the form of learning modules. This acts as a virtual classroom for users to learn about a variety of topics of their choice and provides a form of learning that is both educative and fun.",
      content: "Video based Learning Essentials",
      image: os2,
      selectedIcon: ideaselected,
      unselectedIcon: idea,
    },
    {
      id: 3,
      title: "Hands-on based Skill Development",
      description:
        "We provide our users with real world project-based learning outcomes. By providing the users with a project-based learning approach, we ensure that the users get a real-world experience of the industry and are better poised to be employable in these fields.",
      content: "Project-based Industry Training",
      image: os3,

      selectedIcon: skillselected,
      unselectedIcon: skills,
    },
    {
      id: 4,
      title: "Live Learning Sessions (Coming soon!)",
      description:
        "Jozuna will soon be launching expert-based live learning sessions integrated within the Jozuna platform so that the users can learn from industry experts on their personalized areas and learn to apply these in real world experiences to groom themselves professionally. The cutting edge platform would also provide users with an ability to ask doubts in real time and get it clarified by the experts in the respective fields to promote collaborative learning.",
      content: "Expert Driven Live Sessions - Real World Experiences",
      image: os3,
      selectedIcon: liveselected,
      unselectedIcon: live,
    },
    {
      id: 5,
      title: "CodeHub",

      description:
        "Accelerate your tech career with CodeHub, the premier coding platform designed for final-year students, graduates, and competitive programmers aiming to ace their technical interviews.Whether you code in Java, JavaScript, or Python, CodeHub doesn’t just run your code — it elevates it. Our advanced AI engine instantly analyzes your solutions for completeness, clarity, and best practices.Receive comprehensive feedback on code quality, precise space-time complexity analysis, and tailored multi-approach optimization strategies.\n\n Don’t just solve problems — master them. Refine your logic, eliminate inefficiencies, and build interview-ready coding habits with CodeHub. Your dream tech role is just one optimized solution away.",

      content: "Your Ultimate AI-Powered Coding Coach",

      image: os5,
      selectedIcon: codehubSelected,
      unselectedIcon: codehubUnselected,
    },
    {
      id: 6,
      title: "InterviewIQ",

      description:
        "Conquer every interview stage with InterviewIQ, our intelligent mock interview simulator. From technical deep-dives to behavioral and HR rounds, our active AI engine conducts realistic, adaptive interviews. By analyzing your resume, the AI dynamically probes your answers, adapts to your pace, and even provides helpful hints if you get stuck—just like a human interviewer.\n\n Post-interview, unlock an exhaustive performance report covering technical clarity, teachability, body language, and AI-driven resume keyword impact. Need a resume refresh? Seamlessly match your profile to job descriptions, leverage AI to generate professional bullet points from plain text, and optimize your resume to stand out. Turn interview anxiety into your competitive edge.",

      content: "Supercharge Your Prep with InterviewIQ",

      image: os6,
      selectedIcon: interviewHubSelected,
      unselectedIcon: interviewHubUnselected,
    },
  ];

  // State to keep track of the selected card
  const [selectedCard, setSelectedCard] = useState<Card>(cards[0]);
  const [isModalOpen, setModalOpen] = useState(false);

  // Function to handle card selection
  const handleCardClick = (card: Card) => {
    setSelectedCard(card);
  };

  return (
    <div className="os_container">
      <div className="os_services-header">
        {/* <img src={os} alt="imgs" style={{ width: "100%", height:"fit-content",position: "relative" }} /> */}
        <div
          className="header-text-overlay"
          style={{
            backgroundImage: `url(${os})`,
            backgroundSize: "cover",
            backgroundPosition: "right center",
            padding: "20px", // Optional for spacing inside the div
            paddingLeft: "78px",
          }}
        >
          <img
            src={boderos}
            alt="border"
            style={{ width: "66px", height: "6px" }}
          />
          <p
            style={{
              fontSize: "42px",
              margin: "0px",
              fontWeight: "700",
              color: "white",
              fontFamily: "Mazzard",
            }}
          >
            Our Services
          </p>
          <p
            style={{
              fontFamily: "Mazzard",
              margin: "0px",
              padding: "0px",
              fontSize: "16px",
              width: "80%",
            }}
          >
            We believe in holistic development for you, the users of our
            platform. We provide a closed-loop feedback system personalized for
            you to bring out the best in you.
          </p>
        </div>
        <button className="feedback-button" onClick={() => setModalOpen(true)}>
          <img
            src={feedbackIcon}
            alt="feedback"
            style={{ width: "20px", height: "20px" }}
          ></img>
          Feedback!
        </button>
      </div>

      <div className="os_content">
        {/* Left side - Selectable Cards */}
        <div className="os_cards-container">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`os_card ${selectedCard.id === card.id ? "selected" : ""}`}
              onClick={() => handleCardClick(card)}
            >
              <div className="os_card-title-container">
                <img
                  src={
                    selectedCard.id === card.id
                      ? card.selectedIcon
                      : card.unselectedIcon
                  }
                  alt="icon"
                  className="os_card-icon"
                />
                <p
                  className={`os_card-title ${selectedCard.id === card.id ? "os_card-title-selected" : "os_card-title-unselected"}`}
                >
                  {card.title}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Right side - Dynamic Content */}
        <div className="os_content-display">
          <img
            src={selectedCard.image}
            alt="img"
            style={{ width: "fit-content" }}
          />
          <p className="os_content_title">{selectedCard.content}</p>
          <p
            className="os_content-description"
            style={{
              whiteSpace: "pre-line",
            }}
          >
            {selectedCard.description}
          </p>
          {/* You can add an image or other media elements here as needed */}
        </div>
      </div>
      {isModalOpen && <FeedbackModal onClose={() => setModalOpen(false)} />}
    </div>
  );
};

export default OurServicesPage;
